import React from 'react';

import BoxBody from 'components/BoxBody';
import BoxHeader from 'components/BoxHeader';
import Button from 'components/ButtonDeprecated';
import Dialog from 'components/Dialog';
import Link from 'components/Link';
import List from 'components/List';
import ListItem from 'components/ListItem';
import MockSpreadsheet from 'components/MockSpreadsheet';
import Row from 'components/Row';
import Text from 'components/Text';

type Props = {
  onRequestHide: () => void;
};

class TargetByStudentIdHelpDialog extends React.Component<Props, any> {
  render() {
    return (
      <Dialog size="xxsmall" onRequestHide={this.props.onRequestHide}>
        <BoxHeader title="Formatting your list of student numbers" textAlign="left" size="small" />
        <BoxBody size="small">
          <Text color="graphite" lineHeight="xlarge" align="left" size="xsmall">
            <Row size="small">
              <List marker="number" size="large">
                <ListItem>
                  In a new spreadsheet, create a single column with the header{' '}
                  <Text element="code">student_number</Text>
                </ListItem>
                <ListItem>
                  Add one student number to each row in the{' '}
                  <Text element="code">student_number</Text> column
                </ListItem>
                <ListItem>
                  Save your file in the CSV file format <code>(.csv)</code>
                </ListItem>
              </List>
            </Row>
            <Row size="small">
              <Text element="p">
                <Text weight="semibold">Note:</Text> You’ll see parent contacts associated with the
                students you want to reach in the next step
              </Text>
              <Text element="p">
                Need help?{' '}
                <Link
                  eventKey="announcements.target_by_student_id.upload_list.download_template.click"
                  href="/assets/csv/student_number_list.csv"
                >
                  Download a template
                </Link>
              </Text>
            </Row>
          </Text>
          <Row size="small">
            <MockSpreadsheet
              title="absent_students.csv"
              columnHeaders={['student_number']}
              rows={[['123456'], ['654321']]}
            />
          </Row>
          <Button onClick={this.props.onRequestHide}>Got it</Button>
        </BoxBody>
      </Dialog>
    );
  }
}

export default TargetByStudentIdHelpDialog;
